module.exports = __webpack_public_path__ + "img/TelefonicaWeb-Hand.a4fc3a00.svg";